<div id="wtb-edge-container">
  <div class="brandWidget">
    <div id="nv-logo-tabs" class="tab_menu" *ngIf="gardenData?.tabs?.length">
      <ul class="tab_menuRow">
        <li *ngFor="let tab of gardenData.tabs"
            [class.active]="tab.tabId === activeTabId"
            [attr.data-tab]="'nv-' + tab.tabId"
            (click)="activeTabId = tab.tabId">
          {{ tab.tabName }}
        </li>
      </ul>
    </div>

    <div class="tab-content" id="nv-tab-container">
      <div *ngFor="let tab of gardenData?.tabs"
           class="tab-pane wtb-tab-pane"
           [class.active]="tab.tabId === activeTabId"
           [id]="'nv-' + tab.tabId">
        
        <!-- Logo Partners -->
        <ul class="brandList" *ngIf="getLogoPartners(tab.tabId).length > 0">
          <li *ngFor="let partner of getLogoPartners(tab.tabId)">
            <a [href]="partner.redirectUrl"
               [attr.alt]="partner.retailerName"
               [attr.title]="partner.retailerName"
               target="_blank">
              <img [src]="partner.logo"
                   [alt]="partner.retailerName"
                   [title]="partner.retailerName">
            </a>
          </li>
        </ul>

        <!-- Other Partners Section -->
        <ng-container *ngIf="shouldShowOtherPartners(tab.tabId)">
          <h3 style="display: flex; width: 100%; justify-content: center; max-width: 1280px; margin: 0 auto; padding-top: 30px; color: #fff; font-size: 1rem;">
            {{ 'other_partners' | translate }}
          </h3>
          <ul class="brandList brandListnologo"
              [class.brandList-many]="getOtherPartners(tab.tabId).length > 1">
            <li *ngFor="let partner of getOtherPartners(tab.tabId)">
              <a [href]="partner.redirectUrl"
                 [attr.alt]="partner.retailerName"
                 [attr.title]="partner.retailerName"
                 target="_blank">
                {{ partner.retailerName }}
              </a>
            </li>
          </ul>
        </ng-container>
      </div>
    </div>
  </div>
</div> 